import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VLayout,{staticClass:"systock-breadcrump text-uppercase",attrs:{"align-center":""}},[_c(VFlex,{attrs:{"xs5":""}},[_c(VBreadcrumbs,[_c(VBreadcrumbsItem,[_c('h4',[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-file-import")]),_vm._v("\n            Produtos Análise Mercado\n          ")],1)])],1)],1)],1),_c(VCard,{attrs:{"flat":""}},[_c(VTabs,{attrs:{"centered":""}},[_c(VTab,[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-align-vertical-bottom")]),_vm._v("\n        Análise Mercado\n      ")],1),_c(VTabItem,{staticClass:"ma-0"},[_c('Tabela')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }